export const cacheBuster = async version => {
	/* eslint-disable-next-line */
	console.log('Clearing cache...')
	if ('caches' in window) {
		const names = await caches.keys()
		await Promise.all(names.map(name => caches.delete(name)))
	}
}
